import { render, staticRenderFns } from "./RateAction.vue?vue&type=template&id=79bcbd98&"
import script from "./RateAction.vue?vue&type=script&lang=js&"
export * from "./RateAction.vue?vue&type=script&lang=js&"
import style0 from "./RateAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports